module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-box-year calendar-bg-white"
  }, [_c('div', {
    staticClass: "calendar-text-center",
    staticStyle: {
      "font-size": "1.4em"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-left fa-lg",
    staticStyle: {
      "padding-right": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.setSelectYear(-1)
      }
    }
  }), _vm._v("\n\t\t" + _vm._s(_vm.setYearOutput(_vm.selectingYear)) + "\n\t\t"), _c('i', {
    staticClass: "fa fa-caret-right fa-lg",
    staticStyle: {
      "padding-left": "11px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.setSelectYear(1)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6004abc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsCalendarWorkTime/hrmsCalendarYear.vue
// module id = 3813
// module chunks = 1